import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import AmbientBackground from "./components/AmbientBackground";
import KonamiToast from "./components/KonamiToast";
import NavBar from "./components/NavBar";
import { useKonamiCode } from "./hooks/useKonamiCode";
import { logEvent } from "./utils/analytics";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectCaseStudy from "./pages/ProjectCaseStudy";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Secret from "./pages/Secret";

function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const [konamiVisible, setKonamiVisible] = useState(false);

  useKonamiCode(() => {
    setKonamiVisible(true);
    logEvent("konami_unlocked", { path: location.pathname });
    navigate("/secret");
  });

  useEffect(() => {
    if (!konamiVisible) return;
    const timeout = setTimeout(() => setKonamiVisible(false), 4000);
    return () => clearTimeout(timeout);
  }, [konamiVisible]);

  return (
    <div className="relative bg-bg text-primary min-h-screen overflow-x-hidden">
      <AmbientBackground />
      <NavBar />
      <KonamiToast visible={konamiVisible} onDismiss={() => setKonamiVisible(false)} />
      <div className="relative z-10 pt-20 pb-12">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectCaseStudy />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/secret" element={<Secret />} />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}
